<template>
    <div>
        <div class="title">
            <h2>中惠科技 让工程更智慧</h2>
            <p>领先的工程建设SAAS服务提供商</p>
        </div>
        <!-- <div class="content" >
            <div
                class="item top"
                v-for="item in topData"
                :key="item.title"
                @mouseenter="showArrow(item,false)"
                @mouseleave="hiddenArrow(item,false)"
                @click="gotoDetails(item.pathUrl)"
            >
                <img
                    :src="item.img"
                    class="img"
                />
                <div class="p_title">
                    <p class="sub_title">{{ item.title }}</p>
                    <i
                        class="iconfont icon-youjiantou"
                        :style="{color:item.showArrow ? '#8c2396':'#131415'}"
                    ></i>
                </div>

                <p class="text">{{ item.text }}</p>
            </div>
            <div
                class="item bottom"
                @mouseenter="showArrow(bottomData,true)"
                @mouseleave="hiddenArrow(bottomData,true)"
                @click="gotoDetails(bottomData.pathUrl)"
            >
                <img
                    :src="bottomData.img"
                    class="img"
                />
                <div class="p_title">
                    <p class="sub_title">{{ bottomData.title }}</p>
                    <i
                        class="iconfont icon-youjiantou"
                        :style="{color:bottomData.showArrow ? '#8c2396':'#131415'}"
                    ></i>
                </div>
                <p class="text">{{ bottomData.text }}</p>
            </div>
        </div> -->

        <solution-new :sub-title-show="false" style="padding-top:60px"></solution-new>

    </div>
</template>

<script>
import CONFIG_PROJECT from '@config/project';
import solutionNew from '../index/component/solution-new.vue';
export default {
    head: {
        title: `产品和服务·${CONFIG_PROJECT.title}`,
    },
    components: {
        solutionNew,
    },
    data() {
        return {
            topData: [
                {
                    title: '招标采购电子交易解决方案',
                    text: '国内领先的招标采购数智化整体解决方案',
                    img: '/images/products/1.png',
                    pathUrl: 'zhao-biao-cai-gou',
                },
                {
                    title: '企业教培考核数字化解决方案',
                    text: '政企单位研发的线上培训及考试一体化解决方案',
                    img: '/images/products/2.png',
                    pathUrl: 'qi-ye-jiao-pei',
                },
                {
                    title: '全过程工程项目管理信息化解决方案',
                    text: '致力于帮助客户解决工程项目管理领域的管理问题',
                    img: '/images/products/3.png',
                    pathUrl: 'gong-cheng-xiang-mu',
                },
                {
                    title: '行政服务平台数智化解决方案',
                    text: '针对工程咨询企业特点的信息化解决方案',
                    img: '/images/products/4.png',
                    pathUrl: 'xing-zheng-fu-wu',
                },
            ],
            bottomData: {
                title: '企业招标采购一体化解决方案',
                text: '以大数据底座为支撑，以采购管理业务为主线的电子招标采购管理平台',
                img: '/images/products/5.png',
                pathUrl: 'qi-ye-zhao-cai',
            },
        };
    },
    mounted() {},
    methods: {
        showArrow(item, falg) {
            if (falg) {
                this.$set(this.bottomData, 'showArrow', true);
            } else {
                this.$set(item, 'showArrow', true);
            }
        },
        hiddenArrow(item, falg) {
            if (falg) {
                this.$set(this.bottomData, 'showArrow', false);
            } else {
                this.$set(item, 'showArrow', false);
            }
        },

        gotoDetails(pathUrl){
            console.log(pathUrl);
            let routeData = this.$router.resolve({
                path: `/products/details/${pathUrl}`,
            });
            window.open(routeData.href, '_blank');
        },
    },
};
</script>
<style lang='scss' scoped>
@import '@css/var.scss';
    .title {
        width: 100%;
        height: 365px;
        background: url('/images/products/bg.png') no-repeat;
        background-size: auto 100%;
        background-position: top center;
        text-align: center;
        padding-top: 110px;
        background-color: white;

        h2 {
            font-size: 38px;
            color: #17385c;
        }

        p {
            font-size: 20px;
            letter-spacing: 4px;
            color: #17385c;
            margin-top: 42px;
        }
    }

    .content {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding-bottom: 68px;
        .item {
            background: #f7f7f7;
            border: solid 1px #d3d3d3;
            padding: 21px 26px;
            cursor: pointer;

            &:hover .sub_title {
                color: $primaryColor;
            }
        }

        .top {
            width: 565px;
            height: 220px;
            margin-bottom: 43px;
        }

        .bottom {
            width: 100%;
            height: 220px;
        }

        .img {
            height: 50px;
        }

        .p_title {
            display: flex;
            justify-content: space-between;
            margin-top: 33px;

            .sub_title {
                font-size: 20px;
                color: #131415;
                font-weight: bold;
            }

            i {
                font-size: 24px;
            }
        }

        .text {
            font-size: 16px;
            color: #616161;
            margin-top: 24px;
        }
    }
</style>
